import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pending-color",
  "use": "icon-pending-color-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pending-color\">\n<rect width=\"40\" height=\"40\" rx=\"20\" fill=\"#EFAF41\" />\n<circle cx=\"20\" cy=\"20\" r=\"10\" stroke=\"white\" stroke-width=\"2\" />\n<rect x=\"19\" y=\"14\" width=\"2\" height=\"6\" rx=\"1\" fill=\"white\" />\n<rect x=\"20\" y=\"19\" width=\"7\" height=\"2\" rx=\"1\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/pending-color.svg
// module id = VcPU
// module chunks = 262